import styled from "styled-components";
import { AppBar, MenuItem } from "@mui/material";
import List from "@mui/material/List";

export const AppGridWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

export const AppContainer = styled.div`
  display: flex;
  height: calc(100% - 64px);
  width: 100%;
  overflow-y: auto;
  overflow-x: scroll;
  padding-bottom: 120px;

  /* GlobalStyles 의 "* { scrollbar-width: none }" 을 되돌린다. Chrome 121+ 는 요소에
     scrollbar-width / scrollbar-color 가 auto 가 아니면 아래 ::-webkit-scrollbar
     커스텀 스타일을 통째로 무시하므로, none 이 상속된 채로는 스크롤바가 사라진다.
     auto 로 두어야 커스텀 스크롤바가 항상 보이는 고전 스크롤바로 그려진다. */
  scrollbar-width: auto;

  &::-webkit-scrollbar {
    display: block;
    width: 10px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  /* 원색(#6750A4) 그대로는 너무 진해 보여 반투명으로 연하게 하고, 올렸을 때만 짙어진다. */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(103, 80, 164, 0.6);
    border-radius: 10px;
    background-clip: padding-box;
    border: 2px solid transparent;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(103, 80, 164, 0.8);
  }
  &::-webkit-scrollbar-track {
    background: rgba(103, 80, 164, 0.06);
    border-radius: 10px;
  }
`;

export const UnauthPageWarp = styled.div`
  padding: 100px 20px;
`;

export const MuiAppBar = styled(AppBar)`
  &.MuiPaper-root {
    position: relative;
  }
  .MuiToolbar-root {
    background-color: #6750a4;
    height: 64px;
    .MuiToolbar-root {
      min-height: 64px;
    }
  }
`;

export const MuiMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    height: 56px;
    border-radius: 0 50px 50px 0;
  }
  &.MuiMenuItem-root:hover {
    background:
      linear-gradient(0deg, rgba(103, 80, 164, 0.05), rgba(103, 80, 164, 0.05)),
      #fffbfe;
  }
  &.Mui-selected {
    background:
      linear-gradient(0deg, rgba(103, 80, 164, 0.05), rgba(103, 80, 164, 0.05)),
      #fffbfe !important;
  }
`;

export const NameBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  margin-right: -24px;
  display: block;
  font-size: 12px;
`;

export const MenuList = styled(List)({
  // selected and (selected + hover) states
  "&& .Mui-selected, && .Mui-selected:hover": {
    backgroundColor: "rgba(103, 80, 164, 0.05)",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    "&, & .MuiListItemIcon-root": {
      color: "#6750A4",
    },
  },
  // hover states
  "& .MuiListItem-root:hover": {
    backgroundColor: "rgba(103, 80, 164, 0.05)",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    "&, & .MuiListItemIcon-root": {
      color: "#6750A4",
    },
  },
});

export const RouteBox = styled.div`
  width: 100%;
  max-width: calc(2400px - 256px);
  padding-left: 48px;
  padding-right: 48px;
  height: auto;
`;
